import React from "react";
import { categoryTiles, tomoIncludes, tomos } from "../../data/megapack";
import { E } from "../Emoji";
export function TomosSection() {
  return <section aria-labelledby="tomos" className="bg-night" data-id="element-248" data-mp="1iwf9fxvc9zye">
      <div className="mx-auto max-w-2xl px-5 pb-14" data-id="element-249" data-mp="1e0gqwqwozc5w">
        <div className="relative" data-id="element-250" data-mp="1dx2lf9sqemu8">
          <ul className="grid grid-cols-6 gap-1.5" aria-label="Categorías de fallas" data-id="element-251" data-mp="1913tjc872mp2">
            {categoryTiles.map(c => <li key={c.label} className="flex aspect-[4/5] items-end justify-center rounded-lg border-2 border-white/15 px-0.5 pb-2 text-center text-[10px] font-black leading-tight text-white sm:text-xs" style={{
            backgroundColor: c.color
          }} data-id="element-252" data-mp="26nkowbxdaq86">
                {c.label}
              </li>)}
          </ul>
          <p className="absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-bright px-4 py-1 text-xs font-black uppercase text-white" data-id="element-253" data-mp="lbsz0chftojd">
            <E data-id="element-254" data-mp="o5gx442xhv1e">🧺 6 Tomos completos</E>
          </p>
        </div>

        <div className="mt-10 rounded-2xl border border-line/50 bg-navy p-5" data-id="element-255" data-mp="o69wgjzk5i9i">
          <h2 id="tomos" className="text-xl font-black uppercase text-bright" data-id="element-256" data-mp="t38sx96p21av">
            <E data-id="element-257" data-mp="f5k4xshbye1l">🧺 6 Tomos completos</E>
          </h2>
          <ul className="mt-4 space-y-3" data-id="element-258" data-mp="f750nlfds311">
            {tomos.map(t => <li key={t.number} className="flex gap-3" data-id="element-259" data-mp="j4t1t67o2s1d">
                <span className="text-xl leading-none" data-id="element-260" data-mp="5eh4msw8633d"><E data-id="element-261" data-mp="5dehmw20wksq">{t.emoji}</E></span>
                <p className="text-sm leading-snug text-mute" data-id="element-262" data-mp="a5pfltd7dwin">
                  <span className="block font-black uppercase text-white" data-id="element-263" data-mp="a70ilqytr08p">
                    Tomo {t.number} — {t.label}
                  </span>
                  {t.description}
                </p>
              </li>)}
          </ul>
          <ul className="mt-5 flex flex-wrap gap-1.5 border-t border-line/40 pt-4" data-id="element-264" data-mp="3ilr5vr8d1x6o">
            {tomoIncludes.map(i => <li key={i} className="rounded-full bg-navy-2 px-2.5 py-1 text-xs font-bold text-white" data-id="element-265" data-mp="3njkess11t5an">
                <E data-id="element-266" data-mp="1t55hk17imkt3">{`✅ ${i}`}</E>
              </li>)}
          </ul>
        </div>

        <div className="mt-12 text-center" data-id="element-267" data-mp="1ocm2t0x3djmp">
          <h2 className="text-3xl font-black text-white" data-id="element-268" data-mp="1obu6tozl1jvw">
            <E data-id="element-269" data-mp="1jfdk8z817dkx">🎁 5 BONOS ESTRATÉGICOS</E>
          </h2>
          <p className="mt-1 text-sm font-black uppercase tracking-wide text-bright" data-id="element-270" data-mp="1fcyxw555lvow">Siempre incluidos</p>
        </div>
      </div>
    </section>;
}